// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__ijl-V","topBottomGutter":"Layout_topBottomGutter__1hs5s"};